export default __webpack_public_path__ + "static/media/edit-white.82343d93.svg";